import { Dialog, DialogContent, DialogActions, Button } from '@mui/material';
import React, { useState, useEffect, useRef } from 'react';
import { loadingKtvAmplifierDataComponent, loadingOpDataComponent } from '../../../LoadingData/LoadingDataComponents';
import { WriteKtvAmplifierNode, WriteOpNode } from '../../../WriteData/WriteHighwayCommunications';
import CustomSnackbar from '../../../Components/CustomSnackbar';
import { Snackbar } from '@mui/material';


const KtvEditingDialogNode = ({ open, onClose, latitude, longitude, canton, area, user, cantonRefresh, hid, entrance}) => {

  const { showSnackbar, snackbarOpen, handleCloseSnackbar, snackbarMessage, snackbarClass } = CustomSnackbar();

 //const commentTextAreaRefAmplifierData = useRef(null);
 //const commentTextAreaRefFob = useRef(null);

  //const [commentAmplifierData, setCommentAmplifierData] = useState('');
  //const [commentFob, setCommentFob] = useState('');
  const [ktvAmplifierData, setKtvAmplifierData] = useState([]);
  const [oPData, setOpData] = useState([]);
  const [selectedOp, setSelectedOp] = useState(null);
  const [selectedAmplifierData, setSelectedAmplifierData] = useState(null);
  const [isVisibleAmplifier, setIsVisibleAmplifier] = useState(false);
  const [isVisibleOp, setIsVisibleOp] = useState(false);

   //загрузка KtvAmplifier
   useEffect(() => {
    const fetchKtvAmplifierData = async () => {
      try {
        const data = await loadingKtvAmplifierDataComponent();
        setKtvAmplifierData(data);
      } catch (error) {
       // console.error("Error in fetchFobData:", error);
      }
    };
    fetchKtvAmplifierData(); 
  }, []); 

   //загрузка OP
     useEffect(() => {
      const fetchOpData = async () => {
        try {
          const data = await loadingOpDataComponent();
          setOpData(data);
        } catch (error) {
         // console.error("Error in fetchFobData:", error);
        }
      };
      fetchOpData(); 
    }, []); 

  const handleChangeAmplifierData = (event) => {
    const selectedAmplifierData = event.target.value;
    setSelectedAmplifierData(selectedAmplifierData);
  };
  
  // const handleCommentChangeAmplifierData = (event) => {
  //   setCommentAmplifierData(event.target.value);
  // }

  const handleChangeOp = (event) => {
    const selectedOp = event.target.value;
    setSelectedOp(selectedOp);
  };
  
  // const handleCommentChangeOp = (event) => {
  //   setCommentOp(event.target.value);
  // }
  
  async function amplifierDataSave(event) {
     WriteKtvAmplifierNode(event, selectedAmplifierData, cantonRefresh,setSelectedAmplifierData,  hid, entrance, showSnackbar);
  }

  async function oPSave(event) {
     WriteOpNode(event, selectedOp, cantonRefresh,setSelectedOp,  hid, entrance, showSnackbar);
  }


  function toggleVisibilityAmplifier() {
    setIsVisibleAmplifier(!isVisibleAmplifier);
  }

  function toggleVisibilityOp() {
    setIsVisibleOp(!isVisibleOp);
  }

  const handleCloseModal = () => {
    setSelectedOp(null);
    setSelectedAmplifierData(null);
    setIsVisibleAmplifier(false);
    setIsVisibleOp(false);
    onClose();
  };

    return (
  
    <Dialog open={open} className="dialogStyle">
    
      <DialogContent>
        <>
      <div>
      <button onClick={toggleVisibilityAmplifier} className={isVisibleAmplifier ? 'buttonIsHideDrawer2' : 'buttonIsHideDrawer'}>
      {isVisibleAmplifier ? 'КТВ усилитель: скрыть' : 'КТВ усилитель: показать'}
    </button>
        {isVisibleAmplifier && (    
      <div className='divСommunicationsDrawer'>
       
       <img src='./amplifier.png' width='30' height='30' style={{ marginRight: "5px" }} />
      
      <label className='textTitleDrawer'>КТВ усилитель</label>
      <hr className="horizontalLineDrawer" />
      <div>
       <select className="selectStyleDrawer" style={{ marginBottom: "5px", marginTop: "10px", marginInlineEnd:"10px" }} onChange={handleChangeAmplifierData} value={selectedAmplifierData}>
          <option value="null">Выберите усилител</option>
          {ktvAmplifierData.map(ktv => (
            <option key={ktv.id} value={ktv.id}>{ktv.model}</option>
          ))}
        </select>
       
        {/* <hr className="horizontalLineDrawer" style={{ marginTop: "10px" }} />           */}

      </div>
      <div >

        {/* <textarea
          className='areaDescriptionDrawer'
          style={{marginInlineEnd: "10px"}}
          placeholder="Комментарий"
          rows={3}
          cols={44}
          value={commentAmplifierData}
          ref={commentTextAreaRefAmplifierData}
          onChange={handleCommentChangeAmplifierData}
        />
        <br/> */}
        <button onClick={amplifierDataSave} style={{marginInlineStart: "0px"}} className='buttonSaveDrawer'>Сохранить</button>
      </div>
    </div>
        )}
    </div>



    <div>
      <button onClick={toggleVisibilityOp} className={isVisibleOp ? 'buttonIsHideDrawer2' : 'buttonIsHideDrawer'}>
      {isVisibleOp ? 'ОП: скрыть' : 'ОП: показать'}
     </button>
        {isVisibleOp && (    
      <div className='divСommunicationsDrawer'>
      <img src='./op.png' width='30' height='30' style={{ marginRight: "5px" }} />
       <label className='textTitleDrawer' style={{marginInlineEnd: "10px"}}>Оптический приемник</label>
       <hr className="horizontalLineDrawer" />
       <div>
        <select className="selectStyleDrawer" style={{ marginBottom: "5px", marginTop: "10px" }} onChange={handleChangeOp} value={selectedOp}>
           <option value="null">ОП</option>
           {oPData.map(op => (
             <option key={op.id} value={op.id}>{op.model}</option>
           ))}
         </select>
         <br/>
        

        

       </div>
       <div >

         {/* <textarea
           className='areaDescriptionDrawer'
           placeholder="Комментарий"
           style={{marginInlineEnd: "10px"}}
           rows={3}
           cols={44}
           value={commentFob}
           ref={commentTextAreaRefFob}
           onChange={handleCommentChangeFob}
         />
          <hr className="horizontalLineDrawer" /> */}

         <button onClick={oPSave} style={{marginInlineStart: "0px"}} className='buttonSaveDrawer'>Сохранить</button>
       </div>
     </div>
        )}
    </div>
        </>

    
      </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseModal} class='buttonIsHideDrawer23'>
            Закрыть
          </Button>
        </DialogActions>

        {/* <ModalDeleteComponentSpecifically
          open={openModalConnectionDelete}
          onClose={() => setOpenModalConnectionDelete(false)}
          id={content.id}
          type={PON_BOX}
          flag={PON_BOX_FLAG}
          groupedCoordinatesWithColorTypeAndWidth={groupedCoordinatesWithColorTypeAndWidth}
          wellData={wellData}
          fobLocationData={fobLocationData}
          couplingLocationData={couplingLocationData}
          ponBoxLocationData={ponBoxLocationData}
          pillarData={pillarData}
        /> */}

       {/* Snackbar */}
        <Snackbar
         anchorOrigin={{
         vertical: 'bottom',
         horizontal: 'left',
         }}
         open={snackbarOpen}
         autoHideDuration={3000}
         onClose={handleCloseSnackbar}
         message={snackbarMessage}
         ContentProps={{
          style: {
            color: snackbarClass === 'snackbarOk' ? '#ffda62' : '#202020'
          }
        }}
      /> 
 {/*
      <DialogPonBoxConnectionComponent
          id={content.id}
          open={openModalConnection}
          onClose={() => setOpenModalConnection(false)}
          user={user}
      /> */}
    </Dialog>

    
  );
}

export default KtvEditingDialogNode;